export const TRANSLATIONS_JP_SHELL_AND_COMMON = {
  "common.yes": "はい",
  "common.no": "いいえ",
  "notifications.title": "通知",
  "notifications.markAllRead": "すべて既読にする",
  "navbar.brand": "RAGシステム",
  "nav.home": "ホーム",
  "nav.expandSidebar": "サイドバーを展開",
  "nav.collapseSidebar": "サイドバーを折りたたむ",
  "nav.notifications": "通知",
  "nav.userMenu": "ユーザーメニュー",
  "nav.help": "ヘルプ",
  "nav.chat": "チャット",
  "nav.upload": "ドキュメントをアップロード",
  "nav.dashboard": "ダッシュボード",
  "nav.profile": "プロフィール",
  "nav.settings": "環境設定",
  "nav.logout": "ログアウト",
  "nav.query": "クエリ",
  "nav.about": "概要",
  "nav.tasks": "タスク",
  "nav.plan": "プラン",
  "plan.tabs.overview": "マイプラン",
  "plan.tabs.detail": "詳細",
  "auth.login": "ログイン",
  "auth.or": "または",
  "auth.signup": "サインアップ",
  "auth.powered_by": "提供：",
  " ": "ダブルクリックでダウンロード",
  "common.close": "閉じる",
  "common.options": "オプション",
  "common.cancel": "キャンセル",
  "nav.documents": "ドキュメント",
  "header.help": "ヘルプ",
  "header.theme.switchToLight": "ライトテーマに切り替える",
  "header.theme.switchToDark": "ダークテーマに切り替える",
  "role.admin": "管理者",
  "role.user": "ユーザー",
  "footer.rights": "全著作権所有。",
  "footer.terms": "利用規約",
  "footer.privacy": "プライバシーポリシー",
  "footer.contact": "連絡先",
  "auth.create_account": "アカウント作成",
  "auth.signup_description": "開始するにはアカウントを作成してください",
  "auth.back_to_login": "ログインに戻る",
  "auth.loading": "読み込み中...",
  "auth.redirecting": "リダイレクト中...",
  "nav.admin": "管理",
  "notifications.empty": "通知はありません",
  "role.executive": "エグゼクティブ",
  "breadcrumbs.input.label": "ファイルの場所",
  "breadcrumbs.popover.create_option": "フォルダを作成",
  "breadcrumbs.modal.label": "フォルダ名",
  "breadcrumbs.modal.button.cancel": "キャンセル",
  "breadcrumbs.modal.button.create": "作成",
  "common.save": "保存",
  "common.email": "メール",
  "common.role": "役割",
  "common.created": "作成日",
  "common.actions": "操作",
  "common.page": "ページ",
  "common.of": "／",
  "common.prev": "前へ",
  "common.next": "次へ",
  "common.status": "ステータス",
  "common.name": "名前",
  "common.records": "件",
  "common.inactive": "非アクティブ",
  "common.activate": "有効化",
  "common.deactivate": "無効化",
  "common.sending": "送信中...",
  "errors.email_required": "メールは必須です。",
  "errors.email_invalid": "メール形式が無効です。",
  "errors.role_required": "役割は必須です。",
  "nav.generate": "生成ドキュメント",
  "nav.knowledge": "ナレッジ",
  "nav.changes": "変更",
  "nav.alerts": "アラート",
  "nav.knowledgeHub": "Knowledge Hub",
};
